import React, { useState } from 'react';
import {
	ListItem,
	ListItemText,
	Typography,
	ListItemSecondaryAction,
	Checkbox,
	Box,
	Tooltip,
	Link
} from '@material-ui/core';
import classNames from 'classnames';
import FilterListIcon from '@material-ui/icons/FilterList';
import styles from './TimeElements.style';
import { PreviewElementContext, PreviewListItemContext } from '../Preview.context';
import dateIcon from 'assets/svgs/date.svg';
import textIcon from 'assets/svgs/text.svg';
import accessTime from 'assets/svgs/access_time.svg';
import integerIcon from 'assets/svgs/nonText.svg';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { hasOwn } from 'helper/helper';
import { isCalFamily, isMTSAndNotDefault } from '../filter/FilterCondition';
import {
	DESCRIPTION,
	TOOLTIP_NAME,
	ALIAS,
	ECOM_ONLY_FLAG,
	MERCHANT_ONLY_FLAG,
	LEARN_MORE,
	EOP_LINK,
	DC_TMPT_LIST,
	ECOM_INVENTORY,
	STR_TMPT_LIST,
	PIVOT_AVAILABLE_TEMPLATES,
	PIVOT_SINGLE_TIME_VALUES,
	FILTER_LOWER,
	COLUMNS_LOWER,
	DATE_KEY
} from 'constants/constant';
import ItemDescription from './ItemDescription';
import PinAttributeButton from '../preview-elements/PinAttributeButton.component';
import { buildBusinessName, enableFilter } from '../Preview.utils';
import { getBaseUrl, determine104WeeksFeatureInFilterList } from 'helper/utils';
import { colors } from 'theme/color-palette';
import { FEATURES } from 'helper/basicFeatureFlag';
import PivotForTime from './PivotForTime.component';
import { UserPortalContext } from 'context/appcontext';
const { DARK_PURPLE } = colors;

function AttrList({
	item,
	disabled = false,
	checked,
	paddingLeft = 16,
	parent = '',
	checkboxDisabled = false,
	disableAttributeForUser = false,
	showCheckbox = true
}) {
	const portalUserContext = React.useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const { businessName, dataType, description, dssName, note, technicalName } = item;
	const [isHover, setIsHover] = useState(null);
	const classes = styles();
	const { filterIcon, showFilter, highlightFilter } = classes;
	const { ENABLE_PINNED_ATTRIBUTE: enablePinnedAttribute } = FEATURES[customerType].PREVIEW_PAGE;

	const isItemHovered = isHover === businessName;
	const { cbHandleListClick } = React.useContext(PreviewListItemContext);
	const { cbUsrSelection, cbSetShowPreviewElement } = React.useContext(PreviewElementContext);

	const hoverFilter = () => {
		let hover = false;
		hover = filterList?.some(
			(el) => el.businessName === item.businessName && el.filter.condition.length !== 0
		);
		if (hover) {
			return true;
		}
		if (isItemHovered) {
			return true;
		}
		return hover;
	};

	const displayFilter = (o) => {
		const isFilterDisabled = disabled || disableAttributeForUser;

		if (!enableFilter(o, templateId, parent)) {
			return null;
		}

		const isCalMember = isCalFamily(o);
		if (isCalMember) {
			if (filterList?.some((filter) => isMTSAndNotDefault(filter))) {
				return null;
			}
			const available = filterList.some((el) => isCalFamily(el) && el.field !== undefined);
			if (available) {
				const dateEl = filterList.some(
					(el) =>
						el.businessName === item.businessName &&
						el.technicalName === item.technicalName &&
						el?.localName === item?.localName
				);
				if (!dateEl || isFilterDisabled) {
					return null;
				}
			}
		}

		let filterIconA11yProps = {
			focusable: !isFilterDisabled,
			'aria-hidden': isFilterDisabled,
			'aria-disabled': isFilterDisabled,
			'aria-label': `Filter by ${parent}, ${businessName}`
		};
		if (!isFilterDisabled) {
			filterIconA11yProps.tabIndex = '0';
			filterIconA11yProps.role = 'button';
		}

		return (
			<FilterListIcon
				id={`filter-${businessName}`}
				fontSize="small"
				className={filterClass}
				{...filterIconA11yProps}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						e.stopPropagation();
						cbUsrSelection([{ ...item, parent }]);
						if (showCheckbox) {
							cbSetShowPreviewElement(COLUMNS_LOWER, true, true);
						} else {
							cbSetShowPreviewElement(FILTER_LOWER, true);
						}
					}
				}}
				onFocus={() => {
					setIsHover(businessName);
				}}
				onBlur={() => {
					setIsHover(null);
				}}
				onClick={(e) => {
					e.stopPropagation();
					cbUsrSelection([{ ...item, parent }]);
					if (showCheckbox) {
						cbSetShowPreviewElement(COLUMNS_LOWER, true, true);
					} else {
						cbSetShowPreviewElement(FILTER_LOWER, true);
					}
				}}
			/>
		);
	};

	const getIcon = () => {
		const icnList = {
			date: dateIcon,
			number: integerIcon,
			string: textIcon,
			time: accessTime
		};
		return icnList[dataType?.toLowerCase()];
	};

	const filterClass = classNames({
		[filterIcon]: true,
		[showFilter]: hoverFilter(),
		[highlightFilter]: isItemHovered
	});

	function getDSSName() {
		if (dssName === undefined || dssName === 'New') {
			return null;
		}

		return (
			<Box>
				<Typography className={`${classes.tooltipText} ${classes.tooltipTop}`}>{ALIAS}</Typography>
				<Typography className={classes.tooltipText}>{dssName}</Typography>
			</Box>
		);
	}

	const getTooltipText = () => {
		const lBussName = buildBusinessName(businessName, templateId);
		const EOP_CHECK = [...DC_TMPT_LIST, ...ECOM_INVENTORY, ...STR_TMPT_LIST].includes(
			Number(templateId)
		);
		const ATTRIB_CHECK = businessName.includes('EOP');
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>{TOOLTIP_NAME}</Typography>
				<Typography className={classes.tooltipText}>{lBussName}</Typography>
				{(!dssName || dssName !== 'New') && getDSSName()}
				<Typography className={`${classes.tooltipText} ${classes.tooltipTop}`}>
					{DESCRIPTION}
				</Typography>
				<Typography className={classes.tooltipText}>{description} </Typography>
				{note && (
					<Typography className={`${classes.tooltipText} ${classes.tooltipTop}`}>
						Note: {note}
					</Typography>
				)}
				{EOP_CHECK && ATTRIB_CHECK && (
					<Typography className={`${classes.tooltipText} ${classes.tooltipTop}`}>
						<Link
							target="_blank"
							href={`${getBaseUrl()}/${EOP_LINK}`}
							style={{ textDecoration: 'none', color: DARK_PURPLE, fontStyle: 'italic' }}>
							{LEARN_MORE}
						</Link>
					</Typography>
				)}
			</Box>
		);
	};

	let enablePinned = true;
	// TODO: should we check if it is a custom data set or a unsaved custom dataset
	if (templateId === -1 || !enablePinnedAttribute) {
		enablePinned = false;
	}

	let moveFilter = false;
	if (item.folderName) {
		moveFilter = true;
	}
	if (!enablePinned) {
		moveFilter = false;
	}

	/**
	 * Show pivot only for specific time attributes for given templates
	 * For 'Hourly Store Inventory' template, Pivot is available for Hour coming under 'dimensions'
	 */
	const hasPivot =
		PIVOT_AVAILABLE_TEMPLATES.includes(Number(templateId)) &&
		['Walmart Calendar', 'dimensions'].includes(parent) &&
		PIVOT_SINGLE_TIME_VALUES.includes(technicalName);

	const isDateColumn = item?.businessName === DATE_KEY;
	let is104FeatureSelected = determine104WeeksFeatureInFilterList(filterList);
	const shouldDisableDateColumn = isDateColumn && is104FeatureSelected;

	return (
		<Box id={`${parent.split(' ').join('-')}-${businessName.split(' ').join('-')}`}>
			<Tooltip
				title={getTooltipText()}
				enterDelay={1000}
				enterNextDelay={1000}
				leaveDelay={1000}
				interactive
				placement="left-start"
				PopperProps={{
					popperOptions: {
						positionFixed: true,
						modifiers: {
							preventOverflow: {
								boundariesElement: 'window'
							}
						}
					}
				}}
				aria-label="add"
				classes={{ tooltip: classes.customWidth }}
				arrow>
				<span>
					<ListItem
						disabled={disabled || disableAttributeForUser || shouldDisableDateColumn}
						id={businessName
							.toLowerCase()
							.trim()
							.replaceAll('/', ' ')
							.replaceAll('(', '')
							.replaceAll(')', '')
							.replaceAll('%', ' ')
							.replaceAll('$', ' ')
							.replaceAll("'", '')
							.split(' ')
							.join('-')}
						className={classes.root}
						onClick={(event) => {
							if (checkboxDisabled && !checked) {
								/**
								 * If checkbox is disabled, Not allowed to check the checkbox
								 * But user can uncheck the checkbox, if it is already checked.
								 */
								return;
							}
							if (showCheckbox) {
								cbHandleListClick(event, item);
							} else {
								if (!enableFilter(item, templateId, parent)) return;
								cbUsrSelection([{ ...item, parent }]);
								cbSetShowPreviewElement(FILTER_LOWER, true);
							}
						}}
						style={{ paddingLeft }}
						onMouseOver={() => setIsHover(businessName)}
						onMouseLeave={() => setIsHover(null)}>
						{showCheckbox && (
							<Checkbox
								checked={checked}
								className={classes.checkbox}
								disabled={disabled || checkboxDisabled || disableAttributeForUser}
								aria-label={`${parent}, ${businessName}`}
							/>
						)}
						<ListItemText className={classes.listItemRow}>
							{/* Pivot */}
							{hasPivot && (
								<PivotForTime isHovered={isItemHovered} technicalName={item?.technicalName} />
							)}
							{/* Filter */}
							<ListItemSecondaryAction>
								<Box className={classes.rightAligned} marginRight={moveFilter ? '32px' : 0}>
									{displayFilter(item)}
								</Box>
							</ListItemSecondaryAction>
							{/* Pin Attributes */}
							{enablePinned && (
								<PinAttributeButton
									pinId={technicalName}
									show={isItemHovered}
									attributeType={parent}
									businessName={businessName}
								/>
							)}
							<Typography className={classes.listItemText}>
								<span className={classes.listIcon}>
									<img src={getIcon()} alt="rb-list-icon"></img>
								</span>
								<ItemDescription
									businessName={businessName}
									checked={checked}
									eComOnly={hasOwn(item, ECOM_ONLY_FLAG)}
									merchantOnly={hasOwn(item, MERCHANT_ONLY_FLAG)}
									hoverState={hoverFilter()}
								/>
							</Typography>
						</ListItemText>
					</ListItem>
				</span>
			</Tooltip>
		</Box>
	);
}

AttrList.propTypes = {
	item: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	checked: PropTypes.bool.isRequired,
	paddingLeft: PropTypes.number,
	parent: PropTypes.string
};

export default AttrList;

// no icon for calendars
